const DEFAULT_LIST_STATE = Object.freeze({
  search: "",
  page: 1,
  sortBy: "displayName",
  sortDesc: false,
});

const SORTABLE_COLUMNS = new Set([
  "displayName",
  "firstowner",
  "permissionModel",
  "environment",
  "state",
]);

function queryString(value) {
  return typeof value === "string" ? value : "";
}

export function applicationListStateFromQuery(query) {
  const page = Number.parseInt(queryString(query.listPage), 10);
  const sortBy = queryString(query.sort);

  return {
    search: queryString(query.q),
    page: Number.isSafeInteger(page) && page > 0 ? page : DEFAULT_LIST_STATE.page,
    sortBy: SORTABLE_COLUMNS.has(sortBy) ? sortBy : DEFAULT_LIST_STATE.sortBy,
    sortDesc: queryString(query.sortDesc) === "true",
  };
}

export function applicationListQuery(query, state) {
  const nextQuery = { ...query };

  delete nextQuery.q;
  delete nextQuery.listPage;
  delete nextQuery.sort;
  delete nextQuery.sortDesc;

  if (state.search !== DEFAULT_LIST_STATE.search) {
    nextQuery.q = state.search;
  }
  if (state.page !== DEFAULT_LIST_STATE.page) {
    nextQuery.listPage = String(state.page);
  }
  if (state.sortBy !== DEFAULT_LIST_STATE.sortBy) {
    nextQuery.sort = state.sortBy;
  }
  if (state.sortDesc !== DEFAULT_LIST_STATE.sortDesc) {
    nextQuery.sortDesc = "true";
  }

  return nextQuery;
}

export function applicationListQueryMatchesState(query, state) {
  const queryState = applicationListStateFromQuery(query);

  return (
    queryState.search === state.search &&
    queryState.page === state.page &&
    queryState.sortBy === state.sortBy &&
    queryState.sortDesc === state.sortDesc
  );
}
